module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_fresh_green-c4d2a5a5b91d0fb6dd321def808f79d7.jpg";